// extracted by mini-css-extract-plugin
export default {"Wrapper":"rbWgLuzVggj0zaSVmbln","Editor":"YEgL1QeADYftg8BFHXC6"};